import { render, staticRenderFns } from "./EmployeeDetailsCardDeactivationForm.vue?vue&type=template&id=630a7cab&scoped=true&"
import script from "./EmployeeDetailsCardDeactivationForm.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailsCardDeactivationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a7cab",
  null
  
)

export default component.exports